import { OverlayTrigger } from "react-bootstrap";

import { QuestionIcon } from "../../components/icons/QuestionIcon";
import { renderTooltip } from "../../components/StyledTooltip/StyledTooltip";
import type { ModelsInfoTableControllerProps } from "./ModelsInfoTableController";

const ModelsInfoTableSm = ({ tableData }: ModelsInfoTableControllerProps) => {
  return (
    <>
      {tableData.map((item, index) => (
        <div key={index} className="billing-item-sm">
          <div className="title">{item.modelName}</div>
          <div className="description-item">
            <span>
              Paid
              <OverlayTrigger
                placement="bottom"
                overlay={renderTooltip(
                  "Amount of paid tokens consumed per model for the current billing period. Paid tokens are generated by the LLM and not coming from cache.",
                )}
              >
                <span className="ms-1">
                  <QuestionIcon size={12} />
                </span>
              </OverlayTrigger>
            </span>

            {item.tokens.paid}
          </div>
          <div className="description-item">
            <span>
              Free
              <OverlayTrigger
                placement="bottom"
                overlay={renderTooltip(
                  "Amount of free tokens consumed per model for the current billing period. Free tokens are generated from the cache and are free of charge.",
                )}
              >
                <span className="ms-1">
                  <QuestionIcon size={12} />
                </span>
              </OverlayTrigger>
            </span>
            {item.tokens.free}
          </div>
          <div className="description-item">
            <span>
              Cost savings
              <OverlayTrigger
                placement="bottom"
                overlay={renderTooltip(
                  "Amount of cost savings per model for the current billing period based on token discounts and caching.",
                )}
              >
                <span className="ms-1">
                  <QuestionIcon size={12} />
                </span>
              </OverlayTrigger>
            </span>
            {item.costSavings}
          </div>
          <div className="description-item">
            <span>Total costs</span>
            <span className="title">{item.totalCost}</span>
          </div>
        </div>
      ))}
    </>
  );
};

export { ModelsInfoTableSm };
